// extracted by mini-css-extract-plugin
export default {"footerBar":"styles_footerBar__aD+Y4","divider":"styles_divider__z+J5p","tablet":"styles_tablet__tGilj","mobile":"styles_mobile__Omosh","desktop":"styles_desktop__LP26C"};